import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { textTranslation, shouldTranslateTo } from '../utils/utils'

import {
  ContainerFlexRow,
  ContainerFlexColumnStart,
  Title,
  Subtitle,
  Paragraph,
  CustomSubtitle,
  Image,
  FlexCenter,
  ContainerFlexColumn,
  SmallRow,
  AwardContainer,
  AwardSection,
  Button,
} from './Utils/CustomClasses'

import AwardsCarousel from './AwardsCarousel'
import HeaderLogo from '../../../../public/images/about-us/header.svg'

const Container = styled.div`
  /* margin-top: 40px;

    @media screen and (max-width: 768px) {
        margin-top: 0;
    } */
`

const Header = styled.div`
  background-color: #f6f0e6;
  flex-wrap: wrap;
  max-width: 100vw;

  @media screen and (max-width: 429px) {
    background-color: #fffbf4;
    padding-bottom: 6vh;
  }
`

const AboutUsTitle = styled(Title)`
  line-height: 132%;
`

const AboutUsSubtitle1 = styled(Subtitle)`
  color: #154549;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 400;
  margin: 17px 0 0 0;
`

const AboutUsSubtitle2 = styled(Subtitle)`
  color: #154549;
  font-weight: 400;
  margin: 10px 0 0 0;
`

const AboutUsImage = styled(Image)`
  @media screen and (max-width: 1025px) {
    margin-top: 30px;
  }

  @media screen and (max-width: 429px) {
    display: none;
  }
`

const TeamContainer = styled.div`
  max-width: 100vw;
  padding: 100px 5vw 50px 5vw;
  background-color: #fff;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 429px) {
    background-color: #f6f0e6;
    padding: 80px 5vw 50px 5vw;
  }
`

const TeamSection = styled.div`
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    column-gap: 30px;
    flex-wrap: wrap;
    max-width: 100vw;

    & > div:nth-child(even) {
      margin-top: 55px;

      @media screen and (max-width: 600px) {
        margin-top: 0px;
      }
    }
  }

  @media screen and (max-width: 1025px) {
    /* & > div:nth-child(even) {
         margin-top: 0;
        } */
    row-gap: 0;
  }

  @media screen and (max-width: 600) {
    flex-direction: column;
    gap: 0;
  }
`

const AboutUsFlexCenter = styled(FlexCenter)`
  background: none;
`

const Member = styled.div`
  background-color: #154549;
  width: 273px;
  height: 100%;
  margin-bottom: 32px;
  padding: 0 0 9px 0;

  img {
    width: 100%;
  }

  h3 {
    margin-top: 8px;
    font-family: 'Open Sans', sans-serif !important;
    color: #fff;
    text-align: center;
    font-family: Open Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%; /* 19.8px */
    margin: 15px 0 0;
  }

  h4 {
    font-family: 'Open Sans', sans-serif !important;
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    margin: 4px 0 4px 0;
  }

  @media screen and (max-width: 1025px) {
    /* width: 200px;
        height: 300px; */

    img {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    width: 200px;
    height: 270px;
    margin-bottom: 15px;
  }
`

const ValuesContainer = styled.div`
  background-color: #fffbf4;
  display: flex;
  flex-direction: column;
  justify-content: row;
  justify-content: center;
  align-items: center;
  padding: 80px 119px 120px 119px;
  gap: 85px;

  flex-wrap: wrap;
  max-width: 100vw;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 80px 69px;
  }

  @media screen and (max-width: 600px) {
    padding: 80px 30px;

    h1,
    h2 {
      text-align: center;
    }
  }
`

const ValueRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 22px;
  justify-content: center;
  flex-wrap: wrap;

  ${(props) => props.first && `margin: 0 0 34px 0px`};

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    margin: 0 0 34px 0;
  }
`

const Value = styled.div`
  border-radius: 12.328px;
  background: #f6f0e6;
  box-shadow: 0px 11.3722px 19.90134px 0px rgba(0, 0, 0, 0.08);

  width: 277px;
  padding: 20px 42px 42px 42px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: space-between;

  img {
    width: 57px;
    padding-bottom: 21px;
  }

  h5 {
    color: #154549;
    font-family: 'Open Sans', sans-serif !important;
    font-size: 23.745px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 35.618px */
  }

  h3 {
    color: #154549;
    font-family: 'Open Sans', sans-serif !important;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0em;
    text-align: left;
  }
`

const AwardsSection = styled.div`
  background-image: linear-gradient(#ffeadc, #fff8f2);
  text-align: center !important;
  padding: 100px 8vw 80px 8vw;

  @media only screen and (max-width: 600px) {
    text-align: left;
  }
`

const CardContainer = styled.div`
  width: auto;
  ${(props) => props.align && `align-self: ${props.align}`};

  img {
    width: 100%;
  }
`

const CardText = styled.div`
  background-color: #154549;
  padding: 16px;
  text-align: center;

  p,
  a {
    color: #fff;
  }
`

const ImageCover = styled.div`
  img {
    width: 100vw;
    margin-bottom: 100px;

    @media screen and (max-width: 768px) {
      height: 250px;
      object-fit: cover;
    }
  }
`

const CopyContainerFlexColumn = styled(ContainerFlexColumn)`
  background-color: #154549;
  flex-wrap: wrap;
  max-width: 100vw;
  justify-content: center;
  align-items: flex-start;
`

const HowItStartedContainer = styled.div`
  margin: 0 10vw 30px 10vw;
`

const RowArticles = styled(SmallRow)`
  width: 80vw;
  gap: 25px;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const BreakLine = styled.div`
  flex-basis: 100%;
`

const TextContainer = styled.div`
  padding: 0 5vw 0 5vw;
`

const BecomeMemberSection = styled.div`
  background-color: #154549;
  padding: 6vh 0 8vh 0;
  text-align: center;
`

const DividerSectionDiv = styled.div`
  margin-top: -1px;
  margin-bottom: -1px;
  height: auto;
  /* background-color: red; */

  background-color: ${({ colored }) => (colored ? colored : '#FFFFFF')};

  img {
    width: 100vw;
    ${(props) =>
      props.flipV && !props.flipH ? 'transform: rotate(180deg);' : ''}
    ${(props) =>
      props.flipH && !props.flipV
        ? 'transform: scaleX(-1);-webkit-transform: scaleX(-1);'
        : ''}
    ${(props) =>
      props.flipV && props.flipH
        ? 'transform: rotate(180deg) scaleX(-1);-webkit-transform: rotate(180deg) scaleX(-1);'
        : ''}
  }

  @media screen and (max-width: 429px) {
    display: none;
  }
`

const RedButton = styled(Button)`
  background-color: #eb5e55;
`

const AboutUs = () => {
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()

    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('about-us', language)
  }, [])

  const TeamMember = ({ image, name, role }) => {
    return (
      <Member>
        <img src={image} />
        <h3>{name}</h3>
        <h4>{role}</h4>
      </Member>
    )
  }

  const ValueItem = ({ text, icon, subtext }) => {
    return (
      <Value>
        <img src={icon} />
        <div>
          <h5 dangerouslySetInnerHTML={{ __html: `${text}` }}></h5>
          <h3>{subtext}</h3>
        </div>
      </Value>
    )
  }

  const Award = ({ title, text, image }) => {
    return (
      <AwardContainer>
        <div>
          <img src={image} />
        </div>
        <Subtitle
          size="18px"
          sizemd="18px"
          sizesm="18px"
          bold
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        ></Subtitle>
      </AwardContainer>
    )
  }

  const HowItStarted = ({ image, topicOne, topicTwo }) => {
    return (
      <HowItStartedContainer>
        <ContainerFlexRow center gap="100px" gapMd="15px">
          <div>
            <Subtitle
              bold
              color="#fff"
              size="27px"
              sizemd="27px"
              sizesm="17px"
              margin="0 0 30px 0"
              dangerouslySetInnerHTML={{
                __html: `${topicOne.title}`,
              }}
            ></Subtitle>
            <Paragraph
              color="#fff"
              dangerouslySetInnerHTML={{
                __html: `${topicOne.content}`,
              }}
            />
          </div>

          <div>
            <Subtitle
              color="#fff"
              bold
              size="27px"
              sizemd="27px"
              sizesm="17px"
              margin="0 0 30px 0"
              dangerouslySetInnerHTML={{
                __html: `${topicTwo.title}`,
              }}
            ></Subtitle>

            <Paragraph
              color="#fff"
              dangerouslySetInnerHTML={{
                __html: `${topicTwo.content}`,
              }}
            />
          </div>
        </ContainerFlexRow>
      </HowItStartedContainer>
    )
  }

  const ArticlesOrSomethingElse = () => {
    const Card = ({ image, text, align, linkText }) => (
      <CardContainer align={align}>
        <img src={image} />
        <CardText>
          <p>{text}</p>
          <Link to="/">{linkText}</Link>
        </CardText>
      </CardContainer>
    )

    return (
      <RowArticles gap="73px" style={{ minHeight: '568px' }}>
        <Card
          align="end"
          image="/images/about-us/articles/image1.png"
          text={pageText[42]}
          linkText={pageText[43]}
        />
        <Card
          align="center"
          image="/images/about-us/articles/image2.png"
          text={pageText[44]}
          linkText={pageText[45]}
        />
        <Card
          align="start"
          image="/images/about-us/articles/image3.png"
          text={pageText[46]}
          linkText={pageText[47]}
        />
      </RowArticles>
    )
  }

  const DividerSection = ({ img, colored, flipV, flipH }) => {
    return (
      <DividerSectionDiv colored={colored} flipV={flipV} flipH={flipH}>
        <img src={`/images/homepage-v2/${img}`} />
      </DividerSectionDiv>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <Header>
        <ContainerFlexRow
          gap="50px"
          gapMd="30px"
          padding="10vh 5vw 4vh 5vw"
          paddingMd="7vh 7vw 4vh 7vw"
          paddingSm="5vh 10vw 4vh 10vw"
        >
          <ContainerFlexColumnStart
            gap="15px"
            gapMd="15px"
            padding="0 40px 0 0"
            paddingMd="0"
            paddingSm="0"
            width="60%"
            widthMd="100%"
          >
            <AboutUsTitle
              size="48px"
              sizemd="48px"
              sizesm="38px"
              marginsm="0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[0]}`,
              }}
            ></AboutUsTitle>
            <AboutUsSubtitle1
              bold
              size="27px"
              sizemd="27px"
              sizesm="25px"
              marginsm="0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[1]}`,
              }}
            ></AboutUsSubtitle1>
            <AboutUsSubtitle2
              size="21px"
              sizemd="21px"
              sizesm="20px"
              marginsm="15px 0 15px 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[2]}`,
              }}
            ></AboutUsSubtitle2>
          </ContainerFlexColumnStart>

          <AboutUsImage>
            <img src={HeaderLogo} />
          </AboutUsImage>
        </ContainerFlexRow>
      </Header>

      {/* Divider */}
      <DividerSection
        img={'divider4.svg'}
        colored={'#fff'}
        flipV={true}
        flipH={true}
      />

      <TeamContainer>
        <AboutUsFlexCenter margin="0 0 80px 0">
          <AboutUsTitle
            bold
            center
            // width="740px"
            margin="0 3vw"
            size="50px"
            sizemd="50px"
            sizesm="30px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[3]}`,
            }}
          ></AboutUsTitle>
        </AboutUsFlexCenter>
        <TeamSection>
          <div>
            <TeamMember
              image={'/images/about-us/personas/peter.jpg'}
              name={pageText[4]}
              role={pageText[5]}
            />
            <TeamMember
              image={'/images/about-us/personas/phil.jpg'}
              name={pageText[6]}
              role={pageText[7]}
            />
            <TeamMember
              image={'/images/about-us/personas/jordi.jpg'}
              name={pageText[8]}
              role={pageText[9]}
            />
            <TeamMember
              image={'/images/about-us/personas/miguel.jpg'}
              name={pageText[64]}
              role={pageText[65]}
            />
            <TeamMember
              image={'/images/about-us/personas/lauren.png'}
              name={pageText[62]}
              role={pageText[63]}
            />
            <TeamMember
              image={'/images/about-us/personas/andre.jpg'}
              name={pageText[59]}
              role={pageText[60]}
            />
            {/* <BreakLine /> */}
          </div>
        </TeamSection>
      </TeamContainer>

      {/* Divider */}
      <DividerSection
        img={'divider5.svg'}
        colored={'#FFFFFF'}
        flipV={false}
        flipH={false}
      />

      <CopyContainerFlexColumn
        padding="7vh 0 8vh 0"
        center
        background="#F8F9F9"
        paddingMd="6vh 0 8vh 0"
        paddingSm="6vh 0 8vh 0"
      >
        <TextContainer>
          <Title
            color="#fff"
            sizesm="36px"
            center
            margin="0 10vw 32px 10vw"
            marginmd="0 10vw 20px 10vw"
            marginsm="0 0 20px 0"
            width="80%"
            dangerouslySetInnerHTML={{
              __html: `${pageText[33]}`,
            }}
          ></Title>

          <Subtitle
            color="#fff"
            size="27px"
            sizesm="18px"
            center
            bold
            margin="0 10vw 32px 10vw"
            marginmd="0 10vw 30px 10vw"
            marginsm="0 0 20px 0"
            width="80%"
            dangerouslySetInnerHTML={{
              __html: `${pageText[34]}`,
            }}
          ></Subtitle>

          <Paragraph
            color="#fff"
            size="22px"
            margin="0 10vw 84px 10vw"
            center
            dangerouslySetInnerHTML={{
              __html: `${pageText[35]}`,
            }}
          ></Paragraph>
        </TextContainer>

        <ImageCover>
          <img src="/images/our-story/banner-zoom.jpg" />
        </ImageCover>
        <HowItStarted
          image="/images/our-story/banner.png"
          topicOne={{
            title: pageText[36],
            content: pageText[37],
          }}
          topicTwo={{
            title: pageText[38],
            content: pageText[39],
          }}
        ></HowItStarted>
      </CopyContainerFlexColumn>

      {/* Divider */}
      <DividerSection
        img={'divider6.svg'}
        colored={'#154549'}
        flipV={true}
        flipH={false}
      />

      <ValuesContainer>
        <div>
          <AboutUsTitle
            color="#154549"
            width="auto"
            size="50px"
            sizemd="50px"
            sizesm="35px"
            margin="0 0 20px 0"
            center
          >
            {pageText[20]}
          </AboutUsTitle>
          <AboutUsSubtitle1
            white
            center
            width="auto"
            size="21px"
            sizemd="22px"
            sizesm="17px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[21]}`,
            }}
          >
            {/* {pageText[21]} */}
          </AboutUsSubtitle1>
        </div>
        <div>
          <ValueRow first>
            {/* Dignity */}
            <ValueItem
              icon={'/images/about-us/icons/1.svg'}
              text={pageText[22]}
              subtext={pageText[49]}
            />
            {/* Imagination */}
            <ValueItem
              icon={'/images/about-us/icons/2.svg'}
              text={pageText[24]}
              subtext={pageText[50]}
            />
            {/* Inclusivity */}
            <ValueItem
              icon={'/images/about-us/icons/3.svg'}
              text={pageText[23]}
              subtext={pageText[51]}
            />
          </ValueRow>
          <ValueRow>
            {/* Bravery */}
            <ValueItem
              icon={'/images/about-us/icons/4.svg'}
              text={pageText[25]}
              subtext={pageText[52]}
            />
            {/* Heart */}
            <ValueItem
              icon={'/images/about-us/icons/5.svg'}
              text={pageText[48]}
              subtext={pageText[53]}
            />
          </ValueRow>
        </div>
      </ValuesContainer>

      {/* Awards */}
      <AwardsSection>
        <CustomSubtitle
          color="#154549"
          size="21px"
          sizemd="1.25rem"
          sizesm="20px"
          margin="0 0 10px 0"
          dangerouslySetInnerHTML={{ __html: pageText[27] }}
        />
        <CustomSubtitle
          bold
          color="#154549"
          size="21px"
          sizemd="1.25rem"
          sizesm="20px"
          margin="0 0 80px 0"
          dangerouslySetInnerHTML={{ __html: pageText[41] }}
        />
        <AwardsCarousel />
      </AwardsSection>

      <BecomeMemberSection>
        <TextContainer>
          <AboutUsTitle
            color="#FFFFFF"
            sizesm="36px"
            center
            margin="0 10vw 32px 10vw"
            marginmd="0 10vw 20px 10vw"
            marginsm="0 0 20px 0"
            width="80%"
            dangerouslySetInnerHTML={{
              __html: `${pageText[54]}`,
            }}
          ></AboutUsTitle>

          <Subtitle
            color="#FFFFFF"
            size="27px"
            sizesm="18px"
            center
            bold
            margin="0 10vw 32px 10vw"
            marginmd="0 10vw 30px 10vw"
            marginsm="0 0 20px 0"
            width="80%"
            dangerouslySetInnerHTML={{
              __html: `${pageText[55]}`,
            }}
          ></Subtitle>

          <RedButton>
            <Link to="/signup">{pageText[56]}</Link>
          </RedButton>
        </TextContainer>
      </BecomeMemberSection>
    </Container>
  )
}

export default AboutUs
